var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMusicRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1213 19.1803H16.2137V16.319H13.3524V14.4114H16.2137V11.5501H18.1213V14.4114H20.9826V16.319H18.1213V19.1803ZM11.4449 16.319H1.90723V14.4114H11.4449V16.319ZM14.3062 12.5039H1.90723V10.5964H14.3062V12.5039ZM14.3062 8.68882H1.90723V6.78128H14.3062V8.68882Z",
    fill: "#EE4950"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMusicRed);
export default __webpack_public_path__ + "static/media/add-music-red.df371d7d1b5c8d1c912f187680b92ba1.svg";
export { ForwardRef as ReactComponent };